module.exports = __webpack_public_path__ + "COBRA Enrollment Guide.pdf";